<template>
    <div class="table-responsive product-create">
        <table class="table table-bordered table-custom mb-0">
            <thead>
            <tr>
                <th>#</th>
                <th></th>
                <th>Company Name</th>
                <th>Address</th>
                <th style="width:130px;">Linked Quotes</th>
                <th>Details</th>
                <th style="width:200px;">Contact Name</th>
                <th>Email</th>
                <th>Sales Rep</th>
                <th>Status</th>
            </tr>
            </thead>
            <template v-if="customerData.customers != null">
                <template v-for="(customer, index) in customerData.customers.data">
                    <tr :id="customer.id" v-on:click="selectCustomer(customer)">
                        <td>{{ getSLNo(index)}}</td>
                        <td><input name="selected_customer" :value="customer.id" type="radio" class="check-box" :checked="selectedCustomer == customer.id"></td>
                        <td>{{customer.company_name}}</td>
                        <td>{{customer.address}},{{customer.city}} {{customer.state}} {{customer.post_code}} {{customer.country ? customer.country.name : ""}}</td>
                        <td>
                            <router-link :to="{ name: 'quotations'}" target="_blank">
                                {{customer.quotations_after_sent_to_customer.length}}
                            </router-link>
                        </td>
                        <td><router-link :to="{name: 'customerDetails', params: {id: customer.id}}" target="_blank" class="btn details-btn"><i class="fa fa-eye" aria-hidden="true"></i> Details</router-link></td>
                        <td>{{customer.customer_contacts[0] ? customer.customer_contacts[0].contact_name : ''}}</td>
                        <td>{{customer.customer_contacts[0] ? customer.customer_contacts[0].email : customer.email}}</td>
                        <td>{{customer.sales_rep ? customer.sales_rep.name : ''}}</td>
                        <td><span :class="[customer.status=='1' ? 'active':'inactive']">{{(customer.status=='1')?'Active':'Inactive'}}</span></td>
                    </tr>
                </template>

            </template>
        </table>

        <div class="btnrow text-left" v-if="customerData.customers != null && customerData.customers.data.length">
            <template>
                <div class="overflow-auto">
                    <b-pagination
                        v-model="current_page"
                        :total-rows="total"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "Customers",
    props: ['selectedCustomer', 'search_filter', 'bus'],
    created() {
        if(localStorage.getItem('token')){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomers();
    },
    mounted() {
        if(this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.bus.$on('getCustomers', this.getCustomers)
    },
    data(){
        return {
            customerData: {
                customers: null,
                config: null,
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        selectCustomer(c) {
            // this.selectedCustomer = c.id;

            this.$emit('selectCustomer', c)
        },
        getCustomers() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.index',{page: this.current_page,search_filter:this.filterForm.search_filter,status_filter:this.filterForm.status_filter} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        this.current_page = data.data.customers.current_page;
                        this.per_page = data.data.customers.per_page;
                        this.total = data.data.customers.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        }
    },
    watch: {
        current_page: {
            handler: function(value) {
                if(value != 1){
                    this.getCustomers();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading',
        ])
    }
}
</script>

<style scoped>

</style>
